export enum GetByTypeEnum {
    force = 'FORCE',
    repository = 'REPOSITORY',
    regular = 'REGULAR',
    repositoryIfRequested = 'REPOSITORY_IF_REQUESTED'
}
